import { ColorModesScale, Theme, ThemeUICSSObject } from 'theme-ui';
import merge from 'lodash-es/merge';
import { setValueByPath } from '@apia/util';
import { baseTheme as baseThemeMaker } from '../base/baseTheme';
import {
  TCustomPalette,
  TParsedPalette,
  TThemeModifier,
} from '../base/colors/types';
import { getThemeColorsObject, parsePalette } from '../base/colors';
import defaultPalette from '../base/colors/defaultPalette';
import forms from '../base/forms';
import { layout } from '../base/layout';

const makeTheme = <T extends Theme>(t: T) => {
  return t;
};

let declaredStyles: ThemeUICSSObject = {};

export function declareStyles(
  path: string,
  styles: ThemeUICSSObject | Record<string, ThemeUICSSObject>,
) {
  const newStyles = {};
  setValueByPath(newStyles, path, styles);
  declaredStyles = merge(declaredStyles, newStyles);
}

export function getMainTheme(
  customTheme?: () => Omit<Theme, 'palette'>,
  customPalette?: TCustomPalette,

  themeModifier?: TThemeModifier,
) {
  const palette = parsePalette(merge({}, defaultPalette, customPalette));
  window.currentPalette = palette;

  const baseTheme = baseThemeMaker() as Theme;

  baseTheme.palette = palette;

  baseTheme.colors = getThemeColorsObject(
    baseTheme,
  ) as unknown as ColorModesScale;
  baseTheme.forms = forms(baseTheme) as any;
  baseTheme.layout = merge(layout(baseTheme), baseTheme.layout);

  baseTheme.styles = merge({}, customTheme?.().styles, {
    root: baseTheme.layout.root,
  });

  const theme = makeTheme(
    merge(baseTheme, { layout: declaredStyles }, customTheme?.() ?? {}, {
      palette: {} as TParsedPalette,
    }),
  );

  return themeModifier?.(theme) ?? theme;
}
